import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedRecord } from '../selectors/records.selectors';
import postAllowanceRecord from '../services/postAllowanceRecord.service';
export const createAllowanceRecord = createAsyncThunk(
  'records/createAllowanceRecord',
  async (allowanceRecord, { getState }) => {
    const parentRecord = selectSelectedRecord(getState());

    const response = await postAllowanceRecord({
      projectId: parentRecord.project,
      parentRecordId: parentRecord.id,
      allowanceRecord: allowanceRecord,
    });
    return response;
  }
);
